import React from "react";
import TotalMealsTableApp from "../Functionality/TotalMealsTableApp";
import CustomTable from "../../../../../components/table/CustomTable";
import TotalMealsCountListView from "./TotalMealsCountListView";
import NotInformation from "../../../../../components/NotInformation";
import TotalMealsHeader from "./TotalMealsHeader";

/**
 * @email kpozos@ibl.mx
 * @author Karen Yunuen Pozos Arias
 * @title Full Stack Developer
 *
 * @component TotalMealsTable
 * @description
 * Component responsible for rendering the Total Meals table.
 * - Integrates search, pagination, and dynamic table headers & rows using TotalMealsTableApp.
 * - Shows summary cards via TotalMealsCountListView.
 * - Displays a "no data" message when there are no records.
 *
 * @param {Object} props - Props passed to the component, including selected options or filters.
 *
 * @returns {JSX.Element} Rendered table with summary cards and pagination.
 */
const TotalMealsTable = (props) => {
    const {
        searchElement,
        criteria,
        finalArray,
        selectedOption,
        setCriteria,
        setBodyForExport,
        subView,
        subViewChild,
        setSubViewChild,
        handleBtnDinning,
        handleBtnSettings, 
        handleBtnDepartmentPolicies,
        handleBtnTotalMeals,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        setSelectedOption,
        setRender,
        selectedDate,
        setSelectedDate,
        modified,
        setModified,
        prevIsDaily
    } = props;
    // Destructure returned values from the custom hook TotalMealsTableApp
    const {
        t,          // Translation function from i18n
        tableId,    // ID of the table, used for unique identification
        thead,      // Table header JSX
        tbody,      // Table body JSX with data rows
        results,
        setResults,
        option,
        page,
        rowsPerPage,
        attendanceStartDate,
        attendanceEndDate,
        pagination, // Function to render pagination controls
    } = TotalMealsTableApp({
        selectedOption,
        setCriteria,
        finalArray,
        setBodyForExport,
        searchElement,
        setSearchElement,
        modified,
        setModified,
        prevIsDaily
    });

    return (
        <>
            <TotalMealsHeader
                subView={subView}
                subViewChild={subViewChild}
                setSubViewChild={setSubViewChild}
                handleBtnDinning={handleBtnDinning}
                handleBtnSettings={handleBtnSettings}
                handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                handleBtnTotalMeals={handleBtnTotalMeals}
                setBodyForExport={setBodyForExport}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                results={results}
                setResults={setResults}
                option={option}
                rowsPerPage={rowsPerPage}
                attendanceStartDate={attendanceStartDate}
                attendanceEndDate={attendanceEndDate}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                setRender={setRender}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                finalArray={finalArray}
                criteria={criteria}
                page={page}
                prevIsDaily={prevIsDaily}
            />
            {/* Summary cards showing aggregated meal counts or totals */}
            { ( (searchElement || tbody?.body?.length  > 0) && finalArray?.length <= 0 ) &&
                <div className={"col-12"}>
                    <TotalMealsCountListView/>
                </div>
            }

            {/* Conditional rendering: show a "no information" card if there are no rows */}
            { tbody?.body?.length === 0 ?
                <div className={"col-12"}>
                    <NotInformation
                        text={t('looks_like_there_are_no_meals_recorded_yet')}
                        card={true}
                    />
                </div>
                :
                <>
                    {/* Main table rendering */}
                    <div className={"col-12 mt-3"}>
                        <CustomTable
                            tableId={tableId}
                            checkbox={false}          // Disable row selection checkboxes
                            thead={thead}             // Header JSX
                            tbody={tbody}             // Body JSX
                            columnActions={false}     // Disable column-specific action buttons
                        />
                        {/* Render pagination controls */}
                        {pagination()}
                    </div>
                </>
            }
        </>
    );
};

export default TotalMealsTable;
